import config from '../Config.js';

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function getManyMerchants(data) {
    return fetch(config.hostApi + 'merchants', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(data)
    })
}